import { CardType } from './card-type';

/** AuthorizeNet credit card. */
export class AuthorizeNetCreditCard {
  constructor(data) {
    this.lastFourNumbers = data.lastFourNumbers;
    this.cardNumber = data.cardNumber;
    this.expirationDate = data.expirationDate;
    this.issuerNumber = data.issuerNumber;

    /** @type {CardType | null} */
    this.cardType = data.cardType;
  }
}
